import allowNearbyHandlerMap from './allowNearby';
import carriersHandlerMap from './carriers';
import directOnlyHandlerMap from './directOnly';
import featuresHandlerMap from './features';
import generalHandlerMap, {
    INITIAL_STATE,
    INITIAL_SUBSTATE,
} from './general';
import sortHandlerMap from './sort';
import stationsHandlerMap from './stations';
import timingHandlerMap from './timing';
import travelModesHandlerMap from './travelModes';

const handlerMap = {
    ...generalHandlerMap,
    ...allowNearbyHandlerMap,
    ...directOnlyHandlerMap,
    ...carriersHandlerMap,
    ...featuresHandlerMap,
    ...travelModesHandlerMap,
    ...timingHandlerMap,
    ...sortHandlerMap,
    ...stationsHandlerMap,
};

export {
    INITIAL_STATE,
    INITIAL_SUBSTATE,
};

export default function reducer(state = INITIAL_STATE, action) {
    if (!handlerMap.hasOwnProperty(action.type)) {
        return state;
    }

    return handlerMap[action.type](state, action);
}
